import React from 'react';
import {Link} from "react-router-dom";
// import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";


// const SocialShare = [
//     {Social: <FaFacebookF /> , link: 'https://www.facebook.com/'},
//     {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/'},
//     {Social: <FaInstagram /> , link: 'https://www.instagram.com/'},
//     {Social: <FaTwitter /> , link: 'https://twitter.com/'},
// ]

const FooterThree = () => {
    return (
        <div className="footer-style-3 pt--100 pb--30 bg_color--6">
            <div className="wrapper">
                <div className="row align-items-center justify-content-between">
                    <div className="col-lg-12">
                        <div className="inner text-center">
                            <div className="callto-action-area">
                                                                    <h2 className="title text-white mb--25">Правообладание</h2>
                                                                    <p className="description  text-white">Компания не является правообладателем программного обеспечения и игр,
                                                                                               упомянутых на сайте.
                                                                                               Исключительные права переданы правообладателям.
                                                                                               Компания оказывает услуги по техническому и продуктовому
                                                                                               сопровождению на основании договоров.</p>
                                                                    <h2 className="title text-white mb--25">Стоимость</h2>
                                                                    <p className="description  text-white">Стоимость услуг определяется индивидуально в зависимости от объема,
                                                                                               состава и сроков работ и устанавливается на основании технического
                                                                                               задания и договора с заказчиком.</p>
                                <h2 className="title text-white mb--25">Мы открыты для сотрудничества</h2>
                                <p className="description  text-white">Прямо сейчас у нас в разработке находится два
                                    новых игровых проекта. Стать нашим партнером и инвестором можно написав нам</p>

                                <div className="contact-btn">
                                    <Link className="btn-default" to="/contact">Свяжитесь с нами</Link>
                                </div>

                            </div>
                            <div className="logo">
                                <a href="/">
                                    <img src="/assets/images/logo/logo-light.png" alt="Logo Neodinamika"/>
                                </a>
                            </div>
                            {/*<ul className="social-share d-flex justify-content-center liststyle">*/}
                            {/*    {SocialShare.map((val , i) => (*/}
                            {/*        <li key={i}><a href={`${val.link}`}>{val.Social}</a></li>*/}
                            {/*    ))}*/}
                            {/*</ul>*/}
                            <div className="text mt--20">
                                <p>Общество с ограниченной ответственностью "НеоДинамика”, ИНН: 3906219044, ОГРН:
                                    1103925015930
                                </p>
                                <p>Юридический адрес:
                                    236022, Калининградская обл, г Калининград, ул Шиллера, д. 7, литер Б
                                </p>
                                <Link to="/add-about">«Раскрытие информации (Минцифры)»</Link>
                                <p>© Neodinamika Все права защищены</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FooterThree;